/*eslint-disable*/
export const collapse = [
    {
        title: '基础信息',
        ref: 'basicForm',
        formName: 'basicInfo',
        col: 4,
        labelWidth: '100px',
        visible: true,
        formList: [
            {
                label: '待办内容',
                prop: 'todoContent',
                value: 'todoContent',
                type: 'custom',
                rows: 4,
                span: 24,
                disabled: true,
                rule: [
                    { required: false, message: '待办内容不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '完成情况',
                prop: 'content',
                value: 'content',
                type: 'input',
                sourceType: 'input',
                inputType: 'textarea',
                rows: 4,
                span: 24,
                maxlength: 5000,
                showWordLimit: true,
                disabled: true,
                rule: [
                    { required: false, message: '完成情况不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '附件',
                prop: 'fileList',
                value: 'fileList',
                type: 'custom',
                span: 24,
                disabled: true,
                rule: [
                    {
                        required: false,
                        validator: (rule, value, callback) => {
                            if (rule.required && !value.length) {
                                callback(new Error('附件不能为空'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'change'
                    }
                ],
            },
            {
                label: '待办人',
                prop: 'ownerName',
                value: 'ownerName',
                type: 'custom',
                span: 6,
                disabled: true,
                rule: [
                    { required: false, message: '待办人不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '审核人',
                prop: 'approverName',
                value: 'approverName',
                type: 'custom',
                span: 6,
                disabled: true,
                rule: [
                    { required: false, message: '审核人不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '待办开始时间',
                prop: 'todoStartTime',
                value: 'todoStartTime',
                type: 'custom',
                span: 6,
                disabled: true,
                rule: [
                    { required: false, message: '待办开始时间不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '待办结束时间',
                prop: 'todoEndTime',
                value: 'todoEndTime',
                type: 'custom',
                span: 6,
                disabled: true,
                rule: [
                    { required: false, message: '待办结束时间不能为空', trigger: ['change', 'blur'] }
                ],
            },
            {
                label: '待办任务状态',
                prop: 'statusCode',
                value: 'statusCode',
                optionsKey: 'LCRM_TODO_STATUS',
                type: 'custom',
                span: 6,
                disabled: true,
                rule: [
                    { required: false, message: '待办任务状态不能为空', trigger: ['change', 'blur'] }
                ],
            },
        ]
    },
];
